import React from 'react';
import { cn } from '../../../lib/utils';

export interface TaskySwitchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
  wrapperClassName?: string;
}

export const TaskySwitch = React.forwardRef<HTMLInputElement, TaskySwitchProps>(
  ({ className, wrapperClassName, label, disabled, ...rest }, ref) => (
    <label
      className={cn(
        'inline-flex items-center gap-3 select-none cursor-pointer',
        disabled && 'opacity-60 cursor-not-allowed',
        wrapperClassName,
      )}
    >
      <span className="relative inline-block w-10 h-6 shrink-0">
        <input
          ref={ref}
          type="checkbox"
          disabled={disabled}
          {...rest}
          className={cn('peer sr-only', className)}
        />
        <span
          className={cn(
            'absolute inset-0 rounded-full bg-gray-300 transition-colors',
            'peer-checked:bg-primary',
            'peer-focus-visible:ring-2 peer-focus-visible:ring-primary/40 peer-focus-visible:ring-offset-2',
          )}
        />
        <span
          className={cn(
            'absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition-transform',
            'peer-checked:translate-x-4',
          )}
        />
      </span>
      {label && <span className="text-sm text-dark">{label}</span>}
    </label>
  ),
);
TaskySwitch.displayName = 'TaskySwitch';
